exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extra-data-item-child-children-title {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline;\n}\n.context-child-children-title {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n}\n.rule-preview-form-project-package-filter-pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 5px;\n}\n.rule-results-container .bold-title {\n  font-weight: bold;\n}\n", ""]);

// exports
